<div class="fetch-progress-dialog" *ngIf="exportService.state$ | async as exp">
  <div class="fetch-progress-header">
    <span class="fetch-progress-title">
      <i class="pi mr-2"
        [ngClass]="{'pi-file-pdf': exp.exportType === 'pdf', 'pi-file-excel': exp.exportType === 'xlsx', 'pi-file': exp.exportType === 'csv'}"></i>
      {{ exp.exportType === 'pdf' ? 'PDF' : exp.exportType === 'xlsx' ? 'XLSX' : 'CSV' }}
      <span class="fetch-phase-label">&nbsp;· {{ (exp.phase === 'fetching' ? 'local-print.phase-loading' : 'local-print.phase-export') | translate }}</span>
    </span>
    <button mat-icon-button class="fetch-stop-btn" [matTooltip]="'local-print.stop-fetch' | translate" (click)="stop()">
      <mat-icon [svgIcon]="'stop_circle'"></mat-icon>
    </button>
  </div>
  <div class="fetch-progress-body">
    <div class="fetch-progress-bar-wrap">
      <div class="fetch-progress-bar"
        [class.indeterminate]="exp.progress === 0"
        [style.width.%]="exp.progress">
      </div>
    </div>
    <div class="fetch-progress-info">
      <i class="pi pi-spin pi-spinner"></i>
      <ng-container *ngIf="exp.phase === 'fetching'">
        <span>{{ 'local-print.fetching-data' | translate }}</span>
        <span *ngIf="exp.fetchedBytes > 0" class="fetch-progress-pct">
          {{ exp.fetchedBytes >= 1048576 ? ((exp.fetchedBytes / 1048576).toFixed(1) + ' MB') : ((exp.fetchedBytes / 1024 | number:'1.0-0') + ' KB') }}
          <ng-container *ngIf="exp.progress > 0">&nbsp;({{ exp.progress }}%)</ng-container>
        </span>
        <span *ngIf="exp.fetchedBytes === 0 && exp.progress > 0" class="fetch-progress-pct">&nbsp;{{ exp.progress }}%</span>
      </ng-container>
      <ng-container *ngIf="exp.phase === 'converting'">
        <span>{{ 'local-print.phase-export' | translate }}</span>
        <span *ngIf="exp.progress > 0" class="fetch-progress-pct">{{ exp.progress }}%</span>
      </ng-container>
    </div>
  </div>
</div>
